






import Vue from "vue";
import "highlight.js/styles/docco.css";

export default Vue.extend({
  props: {
    html: String
  }
});
